/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ButtonSecondary/view.blocks to change it.
import "DesignSystem/Fonts/Inter-300.css"
import "DesignSystem/Fonts/Inter-400.css"
import React from 'react'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function ButtonSecondary({
  children,
  viewPath = "/DesignSystem/ButtonSecondary",
  alignSelf = "auto",
  borderBottomLeftRadius = 5,
  borderBottomRightRadius = 5,
  borderTopLeftRadius = 5,
  borderTopRightRadius = 5,
  borderLeftWidth = 1,
  borderRightWidth = 1,
  marginLeft = 0,
  marginTop = 0,
  marginRight = 0,
  onClick,
  width = 0,
  isSelected,
  text = "label"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({isSelected})
  return (<React.Fragment
>
<button
  data-testid="ButtonSecondary.ButtonSecondary:1"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--as-1-Z1dPDaQ': alignSelf,'--bblr-3-Z1dPDaQ': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--bbrr-4-Z1dPDaQ': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--btlr-6-Z1dPDaQ': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-7-Z1dPDaQ': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--blw-8-Z1dPDaQ': typeof borderLeftWidth === 'number' ? `${borderLeftWidth}px` : borderLeftWidth,'--brw-9-Z1dPDaQ': typeof borderRightWidth === 'number' ? `${borderRightWidth}px` : borderRightWidth,'--ml-10-Z1dPDaQ': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mt-11-Z1dPDaQ': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mr-12-Z1dPDaQ': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--w-13-Z1dPDaQ': typeof width === 'number' ? `${width}px` : width,'--bc-2-Z1dPDaQ': isSelected ? "rgba(0,147,201, 0.83)" : isHovered ? "rgba(0,147,201, 0.05)" : "#ffffff",'--bc-5-Z1dPDaQ': isSelected ? "#0093c9" : isHovered ? "rgba(0,147,201, 0.83)" : "#e5e5e5"}}
 className={`views-block ${styles.ButtonSecondary1}`}
>
<span
  data-testid="ButtonSecondary.Text"
  data-view-path={viewPath}
 style={{'--c-14-Z1dPDaQ': isSelected ? "#ffffff" : isHovered ? "rgba(0,147,201, 0.83)" : "#323232"}}
 className={`views-text ${styles.Text}`}
>
{text}
</span>
</button>
{children}
</React.Fragment>)
}